import { localStorageKey } from '../../../common/utils/constant';
import { COMMON_RESET_COLLECTION_CHANGE } from './constants';

export function resetCollectionChange() {
  localStorage.setItem(localStorageKey.UPDATE_COLLECTION, JSON.stringify([]));
  return {
    type: COMMON_RESET_COLLECTION_CHANGE,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_RESET_COLLECTION_CHANGE:
      return {
        ...state,
        updatedCollections: [],
      };

    default:
      return state;
  }
}
